import { useEffect, useState } from "react";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import publicRoomsService from "../Services/publicRoomService";
import authService from "../Services/authService";

const SHOWN = 3;
const RECENT_CHECKED = 5;

// Loaded on wide screens only, where Home has a column for it: open public
// games when there are any, otherwise the player's own recent rooms.
export default function useHomeSideRooms() {
  const [rooms, setRooms] = useState({ publicRooms: [], recentRooms: [] });

  useEffect(() => {
    if (!window.matchMedia("(min-width: 1024px)").matches) return;
    let cancelled = false;

    const loadRecent = async () => {
      const saved = (await authService.getUserRooms())
        .slice()
        .sort((a, b) => new Date(b.joinedAt) - new Date(a.joinedAt))
        .slice(0, RECENT_CHECKED);
      const checked = await Promise.all(
        saved.map(async (room) => {
          try {
            const snap = await getDocs(query(collection(db, "rooms"), where("roomId", "==", room.roomId)));
            if (snap.empty) return null;
            const data = snap.docs[0].data();
            return { ...room, status: data.gameStatus || "waiting", playerCount: data.players?.length || 0 };
          } catch {
            return null;
          }
        })
      );
      return checked.filter(Boolean).slice(0, SHOWN);
    };

    (async () => {
      try {
        const { rooms: open } = await publicRoomsService.getPublicRooms();
        if (cancelled) return;
        if (open.length > 0) {
          setRooms({ publicRooms: open.slice(0, SHOWN), recentRooms: [] });
          return;
        }
        const recent = await loadRecent();
        if (!cancelled) setRooms({ publicRooms: [], recentRooms: recent });
      } catch (err) {
        console.error("Error loading rooms for Home:", err);
      }
    })();

    return () => { cancelled = true; };
  }, []);

  return rooms;
}
